import { useAtomValue, useSetAtom } from 'jotai';
import { LuckyPotSizeAtom } from './state';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useResizeDetector } from 'react-resize-detector';
import { useEffect } from 'react';

// 判断lucky-pot组件的容器尺寸
export function useLuckyPotSize() {
  const { isMobile, isTablet, isDesktop } = useAtomValue(LuckyPotSizeAtom);
  return {
    isMobile,
    isTablet,
    isDesktop,
  };
}

/**
 * 样式断点  根据 屏幕尺寸计算
 * isMobile 根据 rush容器尺寸计算
 * 导致有样式响应式偏差，所以要单独处理一些样式
 * 即单独处理  isMobile && (downLg && upMd)
 *
 */
export function useIsMobileDownLgAndUpMd() {
  const { isMobile } = useAtomValue(LuckyPotSizeAtom);
  const theme = useTheme();
  const downLg = useMediaQuery(theme.breakpoints.down('lg'));
  const upMd = useMediaQuery(theme.breakpoints.up('md'));

  return isMobile && downLg && upMd;
}

export function useIsMobileAndUpLg() {
  const { isMobile } = useAtomValue(LuckyPotSizeAtom);
  const theme = useTheme();
  const upLg = useMediaQuery(theme.breakpoints.up('lg'));
  return isMobile && upLg;
}

export function useDownMd() {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('md'));
}

export function useSetRushBoxBreakpoint() {
  const mobileWidth = 735 - 40 - 1;
  const tabletWidth = 735 - 40;
  const setLuckyPotSize = useSetAtom(LuckyPotSizeAtom);

  const { width, ref } = useResizeDetector({
    handleHeight: false,
    refreshMode: 'debounce',
    refreshRate: 500,
  });
  useEffect(() => {
    if (!width) return;
    if (width <= mobileWidth) {
      setLuckyPotSize({
        isMobile: true,
        isTablet: false,
        isDesktop: false,
      });
    } else if (width > mobileWidth && width <= tabletWidth) {
      setLuckyPotSize({
        isMobile: false,
        isTablet: true,
        isDesktop: false,
      });
    } else {
      setLuckyPotSize({
        isMobile: false,
        isTablet: false,
        isDesktop: true,
      });
    }
  }, [width]);

  return { ref };
}

//处理响应式
export function useRushStyles() {
  const isMobileAndUpLg = useIsMobileAndUpLg();
  const isMobileDownLgAndUpMd = useIsMobileDownLgAndUpMd();
  const theme = useTheme();
  const downLg = useMediaQuery(theme.breakpoints.down('lg'));
  const rushGameBoxStyle =
    isMobileAndUpLg || isMobileDownLgAndUpMd ? { height: '350px' } : {};
  const playerBoxStyle = isMobileAndUpLg ? { height: '320px' } : {};
  const playerBoxHeight = isMobileAndUpLg ? '320px' : '436px';
  return {
    rushGameBoxStyle,
    playerBoxStyle,
    playerBoxHeight,
  };
}
